module.exports = __webpack_public_path__ + "static/media/MarketsMedia.af8255a5.svg";